/**
 * The date a "last N days" preset resolves to.
 *
 * Rounded down to midnight UTC rather than counted from the current
 * millisecond. "Last 30 days" is a statement about days, so a bound that moves
 * every time it is read is both wrong in kind and expensive: Apollo keys its
 * cache on the query variables, so a timestamp that never repeats made every
 * render of a date-filtered list a cache miss and a fresh request.
 *
 * Shared by the lists that offer date presets so they cannot drift apart, and
 * by their story mocks, which can only match variables they can predict.
 */
export const presetDateIso = (days: number): string => {
  const midnight = new Date();
  midnight.setUTCHours(0, 0, 0, 0);
  return new Date(midnight.getTime() - days * 24 * 60 * 60 * 1000).toISOString();
};
